/**
 * https://github.com/tldraw/tldraw/blob/main/packages/utils/src/lib/control.ts
 */ import { omitFromStackTrace } from './function';
/** @public */ export const Result = {
    ok (value) {
        return {
            ok: true,
            value
        };
    },
    err (error) {
        return {
            ok: false,
            error
        };
    }
};
/** @internal */ export function exhaustiveSwitchError(value, property) {
    const debugValue = property && value && typeof value === 'object' && property in value ? value[property] : value;
    throw new Error(`Unknown switch case ${debugValue}`);
}
/** @internal */ export const assert = omitFromStackTrace((value, message)=>{
    if (!value) {
        throw new Error(message || 'Assertion Error');
    }
});
/** @internal */ export const assertExists = omitFromStackTrace((value, message)=>{
    // note that value == null is equivilent to value === null || value === undefined
    if (value == null) {
        throw new Error(message !== null && message !== void 0 ? message : 'value must be defined');
    }
    return value;
});
/** @internal */ export function promiseWithResolve() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return Object.assign(promise, {
        resolve: resolve,
        reject: reject
    });
}
